import { navigation as base } from './base';
import { navigation as HR } from './HR';
import { navigation as SK } from './SK';

export const featureConfigMap = {
    base,
    HR,
    SK,
};
